import React, { useState, useEffect } from "react";
import CardComunityMain from './CardsComunity/CardComunityMain'
// import CreateQuestionForm from "./CreateQuestions";
import SearchQuestions from "./SearchQuestionCommunity";
import ListQuestionAndSearch from "./ListQuestion";
import { showLoading, hideLoading } from "../../store/actions/LoadingActions";
import { makeStyles } from '@material-ui/core/styles';
import { Pagination } from '@material-ui/lab'
import CardAnswerQuestion from './CardsComunity/CardAnswerQuestion/CardAnswerQuestion'
import { useHistory, useParams } from "react-router-dom";
import { connect } from 'react-redux';
import Snackbar from '../Snackbar';
import {
    pagingQuestion,
    moreQuestion,
    getAnswers
} from "../../store/actions/CommunityAction";
import ModalSignIn from "../Modal/ModalSignIn/ModalSignIn";
import "./Comunity.scss";
var Scroll = require('react-scroll');
var ElementScroll = Scroll.Element;

const useStyles = makeStyles({
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        margin: '24px 0 0',
    }
});

function ResponseQuestion(props) {
    const {
        // moreAnsweredQuestion,
        // pagingQuestion,
        listQuestion,
        moreQuestion,
        showLoading,
        hideLoading,
        getAnswers,
        question,
        answers,
        authClient,
    } = props
    const history = useHistory();
    const params = useParams();
    const classes = useStyles()

    let isLawyer = false
    if (authClient.role &&
        (authClient.role === 'lawyer' ||
        authClient.role === 'lawFirm')
    ) {
        isLawyer = true
    }

    const [feedbackMessage, setFeedbackMessage] = useState({
        open: false,
        message: '',
        variant: 'success',
    });

    const handleCloseFeedbackMessage = () => {
        setFeedbackMessage({
            open: false,
            message: '',
            variant: 'success',
        });
    };

    const handleSnackbar = message => {
        setFeedbackMessage({
            open: true,
            variant: 'success',
            message,
        });
    }

    useEffect(() => {
        showLoading()
        handleGetListQuestion();
        hideLoading()
    }, []);

    const gettingAnswers = async () => {
        try {
            const answers = await getAnswers(params.id, 1)
            return answers
        } catch (error) {
            throw error;
        }
    }

    const handleChangePage = async (event, value) => {
        try {
            showLoading()
            await getAnswers(params.id, value);
            hideLoading()
        } catch (error) {
            hideLoading()
            throw error;
        }
    };

    const handleGetListQuestion = async () => {
        gettingAnswers()
        moreQuestion()
    }

    const goBack = () => {
        history.push('/comunidad')
    }

    const [ openLogin, setOpenLogin ] = useState(false)

    const handleLoginModal = () => {
        setOpenLogin(!openLogin)
    }

    return(
        <ElementScroll name="responseQuestion" className="comunity">
            <div className="comunity-mainContent">
                <div className='back-container' onClick={goBack}>
                    <img className='img' src='/img/icons/icon-arrow-back.svg' alt='back'/>
                    <p className='backText'>Regresar al listado de preguntas</p>
                </div>
                {question && question.id ?
                    <CardComunityMain
                        body={question}
                        isLawyer={isLawyer}
                        handleSnack={handleSnackbar}
                    /> :
                    null
                }
                <p className='mainTitle'>
                    {question && question.numberAnswers === 1 ?
                        `${question.numberAnswers} respuesta recibida` :
                    question ?
                        `${question.numberAnswers} respuestas recibidas` : 0
                    }
                </p>
                {answers &&
                answers.data &&
                answers.data.response &&
                answers.data.response.length !== 0 ?
                answers.data.response.map(
                    (elem, index, responseArray) =>
                        <CardAnswerQuestion
                            key={elem.id}
                            index={index}
                            body={elem}
                            answers={answers}
                            responseArray={responseArray}
                            isLawyer={isLawyer}
                            handleLoginModal={handleLoginModal}
                        />
                ) : null}
            </div>
            {answers &&
            answers.data &&
            answers.data.response &&
            answers.data.response.length !== 0 ?
                <Pagination
                    classes={{ root: classes.pagination }}
                    count={answers.totalPages}
                    page={answers.actualpage}
                    onChange={handleChangePage}
                    color="primary"
                /> : null
            }
            <SearchQuestions
                inAnswers
                questionId={question.id}
            />

            <div className={
                listQuestion &&
                listQuestion.data &&
                listQuestion.data.length !== 0 ?
                "contentFormsCommunityAnswers" : ''
            }>
                <div className="contentListQuestionAnswers">
                    <ListQuestionAndSearch type="list" inAnswers topicInAnswers={question.topic} />
                </div>
            </div>
            <Snackbar
                open={feedbackMessage.open}
                message={feedbackMessage.message}
                variant={feedbackMessage.variant}
                handleClose={handleCloseFeedbackMessage}
                vertical="top"
                horizontal="right"
                snackbarTop='80px'
            />
            <ModalSignIn
                open={openLogin}
                handleClose={handleLoginModal}
            />
        </ElementScroll>
    )
}

const mapDispatchToProps = dispatch => ({
    pagingQuestion: (search, page) => dispatch(pagingQuestion(search, page)),
    getAnswers: (id, page) => dispatch(getAnswers(id, page)),
    moreQuestion: () => dispatch(moreQuestion()),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    role: state.authClient.role,
    listQuestion: state.communityReducer.listQuestions,
    moreAnsweredQuestion: state.communityReducer.moreAnsweredQuestion,
    question: state.communityReducer.moreAnswers.data.question,
    answers: state.communityReducer.moreAnswers,
    authClient: state.authClient,
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponseQuestion);
